import axios from "axios";
import { API_URL } from "const/constants";

export const fetchAdmissionClientsPage = async ({
  page = 0,
  pageSize = 20,
  search = "",
  filters = {},
}) => {
  const params = {
    page,
    size: pageSize,
    ...(search ? { search } : {}),
    ...(filters.course ? { course: filters.course } : {}),
    ...(filters.university ? { university: filters.university } : {}),
    ...(filters.intake ? { intake: filters.intake } : {}),
    ...(filters.status ? { status: filters.status } : {}),
    ...(filters.caseOfficer ? { caseOfficer: filters.caseOfficer } : {}),
    ...(filters.accountVerificationStatus
      ? { accountVerificationStatus: filters.accountVerificationStatus }
      : {}),
  };
  const res = await axios.get(`${API_URL}/student/clients/page`, { params });
  return res?.data?.data ?? { content: [], totalItems: 0, totalPages: 0 };
};

export const fetchAdmissionsByClientId = async (clientId) => {
  const res = await axios.get(`${API_URL}/student/client/${clientId}/admissions`);
  return res?.data?.data ?? [];
};

export const fetchAdmissionById = async (id) => {
  const res = await axios.get(`${API_URL}/student/${id}`);
  return res?.data?.data ?? res?.data ?? {};
};

export const fetchAdmissionIntakes = async () => {
  const res = await axios.get(`${API_URL}/student/intakes`);
  return res?.data?.data ?? [];
};

export const fetchAllAdmissionsForExport = async () => {
  const res = await axios.get(`${API_URL}/student/export`);
  return res?.data?.data ?? [];
};
